// extracted by mini-css-extract-plugin
export default {"root":"d1qB90"};